<template>
    <div class="auth-layout-wrap">
        <div class="auth-content">
            <div class="card o-hidden">
                <div class="row">
                    <div
                        class="col-md-6 text-center"
                        style="background-size: cover"
                    >
                        <div class="pl-3 auth-right">
                            <div class="auth-logo text-center mt-4">
                            </div>
                            <div class="flex-grow-1"></div>
                            <div class="w-100 mb-30">
                                <router-link
                                    to="signin"
                                    class="btn btn-outline-primary btn-outline-email btn-block btn-icon-text btn-rounded"
                                >
                                    <i class="i-Mail-with-At-Sign"></i> Fazer login
                                </router-link>
                                <a
                                    class="btn btn-outline-primary btn-outline-google btn-block btn-icon-text btn-rounded"
                                    @click="loginWithGoogle"
                                >
                                    <i class="i-Google-Plus"></i> Entrar com Google
                                </a>
                            </div>
                            <div class="flex-grow-1"></div>
                        </div>
                    </div>

                    <b-col md="6">
                        <div class="p-4">
                            <h1 class="mb-3 text-18">Cadastro</h1>
                            <b-form @submit.prevent="submit">
                                <b-form-group label="Seu Nome">
                                    <b-form-input
                                        class="form-control form-control-rounded"
                                        label="Name"
                                        v-model.trim="$v.fName.$model"
                                    >
                                    </b-form-input>

                                    <b-alert
                                        show
                                        variant="danger"
                                        class="error col mt-1"
                                        v-if="!$v.fName.minLength"
                                    >
                                        Nome deve possuir ao menos {{ $v.fName.$params.minLength.min }} letras.
                                    </b-alert
                                    >
                                </b-form-group>

                                <b-form-group label="Email">
                                    <b-form-input
                                        class="form-control form-control-rounded"
                                        label="Name"
                                        type="email"
                                        v-model.trim="email"
                                    >
                                    </b-form-input>
                                </b-form-group>

                                <b-form-group label="Senha">
                                    <b-form-input
                                        class="form-control form-control-rounded"
                                        label="Name"
                                        type="password"
                                        v-model.trim="$v.password.$model"
                                    >
                                    </b-form-input>

                                    <b-alert
                                        show
                                        variant="danger"
                                        class="error col mt-1"
                                        v-if="!$v.password.minLength"
                                    >Mínimo {{ $v.password.$params.minLength.min }} caracteres.</b-alert
                                    >
                                </b-form-group>

                                <b-form-group label="Confirmação de Senha">
                                    <b-form-input
                                        class="form-control form-control-rounded"
                                        label="Name"
                                        type="password"
                                        v-model.trim="$v.repeatPassword.$model"
                                    >
                                    </b-form-input>

                                    <b-alert
                                        show
                                        variant="danger"
                                        class="error col mt-1"
                                        v-if="!$v.repeatPassword.sameAsPassword"
                                        >As senhas devem ser idênticas.</b-alert
                                    >
                                </b-form-group>

                                <b-button
                                    type="submit"
                                    block
                                    variant="primary"
                                    :disabled="
                                        submitStatus === 'PENDING' ||
                                        $v.$invalid
                                    "
                                    class="btn-rounded"
                                    >Cadastrar</b-button
                                >

                                <p
                                    v-once
                                    class="typo__p"
                                    v-if="submitStatus === 'OK'"
                                >
                                    {{ makeToastTwo("success") }}
                                    {{ this.$router.push("/") }}
                                </p>
                                <p
                                    v-once
                                    class="typo__p"
                                    v-if="submitStatus === 'ERROR'"
                                >
                                    {{ makeToast("danger") }}
                                </p>
                                <div
                                    v-once
                                    class="typo__p"
                                    v-if="submitStatus === 'PENDING'"
                                >
                                    <div
                                        class="spinner sm spinner-primary mt-3"
                                    ></div>
                                </div>
                            </b-form>
                        </div>
                    </b-col>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { required, sameAs, minLength } from 'vuelidate/lib/validators'
import { mapGetters, mapActions } from 'vuex'

export default {
    metaInfo: {
        // if no subcomponents specify a metaInfo.title, this title will be used
        title: 'SignUp',
    },

    data () {
        return {
            fName: '',
            email: '',
            password: '',
            repeatPassword: '',
            submitStatus: null,
        }
    },

    validations: {

        // TODO Validação de e-mail aqui

        fName: {
            required,
            minLength: minLength(4),
        },

        password: {
            required,
            minLength: minLength(5),
        },
        repeatPassword: {
            sameAsPassword: sameAs('password'),
        },

        // add input
        // peopleAdd: {
        //   required,
        //   minLength: minLength(3),
        //   $each: {
        //     multipleName: {
        //       required,
        //       minLength: minLength(5)
        //     }
        //   }
        // },
        // validationsGroup:['peopleAdd.multipleName']
    },

    computed: {
        ...mapGetters(['loggedInUser', 'loading', 'error']),
    },

    methods: {
        ...mapActions(['signUserUp']),
        //   validate form
        submit () {
            this.$v.$touch()
            if (this.$v.$invalid) {
                this.submitStatus = 'ERROR'
                return
            }

            this.submitStatus = 'PENDING'
            this.$store
                .dispatch('auth/createWithEmailAndPassword', {
                    email: this.email,
                    password: this.password,
                    displayName: this.fName,
                })
                .then(() => {
                    this.$router.push('/happiness/dashboard')
                })
                .catch(err => {
                    this.submitStatus = 'ERROR'
                    console.log('%c%s:%i', 'color: darkgreen', 'Signin.vue', 231, err)
                })
        },
        loginWithGoogle () {
            this.$store
                .dispatch('auth/loginWithGoogle')
                .then(() => {
                    this.$router.push('/happiness/dashboard')
                })
                .catch(err => {
                    console.log('%c%s:%i', 'color: darkgreen', 'Signin.vue', 241, err)
                })
        },
        makeToast (variant = null) {
            this.$bvToast.toast('Please fill the form correctly.', {
                title: `Variant ${variant || 'default'}`,
                variant: variant,
                solid: true,
            })
        },
        makeToastTwo (variant = null) {
            this.$bvToast.toast('Successfully Created Account', {
                title: `Variant ${variant || 'default'}`,
                variant: variant,
                solid: true,
            })
        },

        inputSubmit () {
            console.log('submitted')
        },
    },
}
</script>
<style>
.spinner.sm {
    height: 2em;
    width: 2em;
}
</style>
